import React from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";

import PropTypes from "prop-types";

const propTypes = {
    files: PropTypes.array,
    onChange: PropTypes.func.isRequired,
};

const defaultProps = {
    files: [],
};

const UploadFormItem = (props) => {
    const onRemove = (file) => {
        const index = props.files.indexOf(file);
        const newFileList = props.files.slice();
        newFileList.splice(index, 1);

        props.onChange(newFileList);
    };

    const beforeUpload = (file) => {
        const newFileList = [...props.files, file];
        props.onChange(newFileList);
        return false;
    };

    return (
        <>
            <Upload onRemove={onRemove} beforeUpload={beforeUpload} files={props.files}>
                <Button icon={<UploadOutlined />}>Select File</Button>
            </Upload>
        </>
    );
};

UploadFormItem.propTypes = propTypes;
UploadFormItem.defaultProps = defaultProps;

export default UploadFormItem;
